var _path, _rect, _rect2, _rect3, _circle, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKeyConfirmed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 0.999999C3.23858 0.999999 1 3.23858 0.999999 6C0.999999 8.76142 3.23858 11 6 11C8.76142 11 11 8.76142 11 6C11 3.23858 8.76142 1 6 0.999999Z",
    stroke: "currentColor",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.5,
    y: 0.5,
    width: 1,
    height: 10,
    rx: 0.5,
    transform: "matrix(-1 -8.74228e-08 -8.74228e-08 1 6 11)",
    fill: "currentColor",
    stroke: "currentColor"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 1,
    height: 3,
    rx: 0.5,
    transform: "matrix(-5.86359e-08 1 1 5.86359e-08 6 15)",
    fill: "currentColor",
    stroke: "currentColor"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 1,
    height: 3,
    rx: 0.5,
    transform: "matrix(-5.86359e-08 1 1 5.86359e-08 6 18)",
    fill: "currentColor",
    stroke: "currentColor"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 1,
    r: 1,
    transform: "matrix(-1 0 0 1 7 5)",
    fill: "currentColor",
    stroke: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7169 14.8625L16.1171 11.8117C16.0421 11.7237 16 11.6043 16 11.4798C16 11.3553 16.0421 11.236 16.1171 11.1479L16.6824 10.4841C16.7574 10.3961 16.8591 10.3467 16.9652 10.3467C17.0713 10.3467 17.173 10.3961 17.248 10.4841L18.9995 12.538L22.7507 8.13745C22.8257 8.04944 22.9275 8 23.0335 8C23.1396 8 23.2414 8.04944 23.3164 8.13745L23.8829 8.80125C23.9579 8.88929 24 9.00867 24 9.13315C24 9.25764 23.9579 9.37702 23.8829 9.46505L19.2826 14.8625C19.2075 14.9506 19.1058 15 18.9997 15C18.8936 15 18.7919 14.9506 18.7169 14.8625Z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyConfirmed);
export default __webpack_public_path__ + "static/media/key_confirmed.ad13700a622546c2eda3eac8c947a3a2.svg";
export { ForwardRef as ReactComponent };